import { useMemo } from "react";
import { getUniqueId } from "../utils/getUniqueId";

export const useUniqueId = () => useMemo(getUniqueId, []);
